/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigurationChange
 */
export interface ConfigurationChange {
    /**
     * 
     */
    scope?: string;
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    occurred_at: Date;
    /**
     * 
     */
    facility_id: string;
    /**
     * Current facility name, including deleted facilities; null for organization changes or unavailable facilities
     */
    facility_name?: string | null;
    /**
     * 
     */
    actor_user_id: string;
    /**
     * 
     */
    actor_name: string;
    /**
     * The scope's value after the change, or null when cleared
     */
    value: any | null;
    /**
     * The scope's value before the change, or null
     */
    previous_value: any | null;
    /**
     * Readable actions, when the key describes its changes
     */
    actions: Array<string>;
}

/**
 * Check if a given object implements the ConfigurationChange interface.
 */
export function instanceOfConfigurationChange(value: object): value is ConfigurationChange {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('occurred_at' in value) || value['occurred_at'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('actor_user_id' in value) || value['actor_user_id'] === undefined) return false;
    if (!('actor_name' in value) || value['actor_name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('previous_value' in value) || value['previous_value'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    return true;
}

export function ConfigurationChangeFromJSON(json: any): ConfigurationChange {
    return ConfigurationChangeFromJSONTyped(json, false);
}

export function ConfigurationChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationChange {
    if (json == null) {
        return json;
    }
    return {
        
        'scope': json['scope'] == null ? undefined : json['scope'],
        'id': json['id'],
        'occurred_at': (json['occurred_at'] == null ? json['occurred_at'] : parseDateTime(json['occurred_at'])),
        'facility_id': json['facility_id'],
        'facility_name': json['facility_name'] === undefined ? undefined : json['facility_name'] === null ? null : json['facility_name'],
        'actor_user_id': json['actor_user_id'],
        'actor_name': json['actor_name'],
        'value': json['value'],
        'previous_value': json['previous_value'],
        'actions': json['actions'],
    };
}

export function ConfigurationChangeToJSON(json: any): ConfigurationChange {
    return ConfigurationChangeToJSONTyped(json, false);
}

export function ConfigurationChangeToJSONTyped(value?: ConfigurationChange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scope': value['scope'],
        'id': value['id'],
        'occurred_at': value['occurred_at'] == null ? value['occurred_at'] : serializeDateTime(value['occurred_at']),
        'facility_id': value['facility_id'],
        'facility_name': value['facility_name'],
        'actor_user_id': value['actor_user_id'],
        'actor_name': value['actor_name'],
        'value': value['value'],
        'previous_value': value['previous_value'],
        'actions': value['actions'],
    };
}

